import { Box, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

const filterSizes = {
  sm: '220px',
  md: '400px',
};

const Container = styled(Box)<{ size?: Size }>(({ theme, size }) => ({
  width: size ? (size === 'auto' ? 'auto' : filterSizes[size]) : '100%',
  flexGrow: size ? 0 : 1,
  flexShrink: size === 'auto' ? 0 : 1,
  flexBasis: size && size !== 'auto' ? filterSizes[size] : 'content',

  [theme.breakpoints.down('md')]: {
    flexBasis: undefined,
    width: '100%',
  },
}));

type Size = 'auto' | 'sm' | 'md';

type Props = {
  pageId?: string;
  size?: Size;
};

const Filter: React.FC<PropsWithChildren<Props>> = ({ children, size }) => {
  return <Container size={size}>{children}</Container>;
};

export default Filter;
